import { configureStore as configureStoreDev } from './configure-store.dev'
import { configureStore as configureStoreProd } from './configure-store.prod'

const selectedConfigureStore =
  process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev

export const { store } = selectedConfigureStore()
